export const actionTypes = {
    SET_PERFORMANCE_LIST_DATA: 'SET_PERFORMANCE_LIST_DATA',
    SET_PERFORMANCE_LIST_CANCEL_TOKEN: 'SET_PERFORMANCE_LIST_CANCEL_TOKEN',
    IS_PERFORMANCE_LIST_FETCHING: 'IS_PERFORMANCE_LIST_FETCHING'
}